module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("我的订单")])]), _vm._v(" "), (_vm.sessionInfo.customerInfo.ssoFlag === 0) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t",
      "href": "#tab"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'all_orders.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t1",
      "href": "#tab1"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'wait_to_pay_1.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t2",
      "href": "#tab2"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'wait_receive.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t3",
      "href": "#tab3"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'complete.png'
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button correlation-with-pay",
    attrs: {
      "id": "t4",
      "href": "#tab4"
    }
  }, [_c('img', {
    staticClass: "img-width",
    attrs: {
      "src": _vm.baseUrl + 'cancel.png'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitPaidOrders,
      "description": "待支付",
      "payFlag": "true",
      "button1Name": _vm.baseUrl + 'cancel_order.png',
      "button2Name": _vm.baseUrl + 'pay.png'
    }
  }), _vm._v(" "), _c('myOrder', {
    attrs: {
      "orderList": _vm.waitDeliverOrders,
      "description": "待收货",
      "button1Name": _vm.baseUrl + 'cancel_order.png'
    },
    on: {
      "response1": _vm.cancelOrderFromWaitPaid
    }
  }), _vm._v(" "), _c('myOrder', {
    attrs: {
      "orderList": _vm.finishedOrders,
      "description": "已完成"
    }
  }), _vm._v(" "), _c('myOrder', {
    attrs: {
      "orderList": _vm.canceledOrders,
      "description": "已取消"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab1"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitPaidOrders,
      "description": "待支付",
      "payFlag": "true",
      "button1Name": _vm.baseUrl + 'cancel_order.png',
      "button2Name": _vm.baseUrl + 'pay.png'
    },
    on: {
      "response2": _vm.orderPay,
      "response1": _vm.cancelOrderFromWaitPaid
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitDeliverOrders,
      "description": "待收货",
      "button1Name": _vm.baseUrl + 'cancel_order.png'
    },
    on: {
      "response1": _vm.cancelOrderFromWaitPaid
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab3"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.finishedOrders,
      "description": "已完成"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab4"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.canceledOrders,
      "description": "已取消"
    }
  })], 1)])])]) : _c('div', {
    staticClass: "content",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab10"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.failAuditOrders,
      "description": "审核失败",
      "button4Name": "审核意见",
      "button5Name": "重新购买"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab6"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitAuditOrders,
      "description": "待审核",
      "button3Name": "价格明细"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab7"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.quoteCompletedOrders,
      "description": "报价完成",
      "button3Name": "价格明细",
      "button4Name": "审核意见"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab8"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.completeOrders,
      "description": "录入完成",
      "button3Name": "价格明细",
      "button4Name": "审核意见"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab9"
    }
  }, [_c('myOrder', {
    attrs: {
      "orderList": _vm.waitSignOrders,
      "description": "待签署",
      "button3Name": "价格明细",
      "button4Name": "审核意见"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t10",
      "href": "#tab10"
    }
  }, [_vm._v("审核失败")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t6",
      "href": "#tab6"
    }
  }, [_vm._v("待审核")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t7",
      "href": "#tab7"
    }
  }, [_vm._v("报价完成")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t8",
      "href": "#tab8"
    }
  }, [_vm._v("录入完成")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "id": "t9",
      "href": "#tab9"
    }
  }, [_vm._v("已签署")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-386a5a72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyOrder/order/AllOrder.vue
// module id = 1603
// module chunks = 8